import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface Props {
    label?: string;
    className?: string;
    size?: 'large' | 'medium' | 'small';
}

/**
 * Circular loading indicator
 * @param {string} label - Aria Label value.
 * @param {string} className - ClassName to apply to the component
 * @param {string} size - Large (5rem), Medium(3rem) or Small(2rem)
 */
export default function CircularLoading({ label, className, size }: Props) {
    const classValue = className ?? '';
    const materialProps = className
        ? {}
        : { display: 'flex', justifyContent: 'center', padding: '24px' };

    function determineSize() {
        switch (size) {
            case 'medium':
                return '3rem';
            case 'small':
                return '2rem';
            default:
                return '5rem';
        }
    }

    return (
        <Box sx={materialProps} className={classValue} aria-label={label ?? 'loading'}>
            <CircularProgress data-testid="loader" size={determineSize()} />
        </Box>
    );
}
